import Auth, { configureAuth } from '@kargotech/tms-core/auth';

configureAuth({
  region: window.AWS_COGNITO_REGION,
  userPoolId: window.AWS_COGNITO_POOL_ID,
  userPoolWebClientId: window.AWS_COGNITO_CLIENT_ID,
});

export default Auth;
